export default {
  devStoreConfig: false,
  api: {
    default: 'https://cryptic-dusk-93277.herokuapp.com/v0',
  },
  features: {
    Ledger: false,
    BTC: false,
    BOT: false,
    Ebay: false,
    balanceSelling: true,
  }
};



// WEBPACK FOOTER //
// ./config/config.client15.js